import { Colors } from '@fourthwall/components';
import styled from 'styled-components';
export const Container = styled.div `
  margin-top: 24px;
`;
export const ArtworkContainer = styled.div `
  display: grid;
  grid-auto-flow: column;
  gap: 24px;
  align-items: center;
  justify-content: flex-start;
`;
export const Artwork = styled.img `
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
export const UploadContainer = styled.div `
  width: 150px;
  height: 150px;
`;
export const ArtworkInfo = styled.div `
  display: grid;
  gap: 4px;
`;
export const ArtworkRecommendation = styled.div `
  color: ${Colors.GS600};
  font-size: 14px;
`;
